
import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';

import { IRefreshBaseImageResult } from '../../serverApi/requests/RefreshBaseImageRequest';
import { BaasEdgePoolAndCluster } from '../../serverApi/resources/BaasEdgePoolAndCluster';
import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';


export function openRefreshBaseImageDialog(actionItem: ActionItemInfo) {
  const { poolId, clusterId, poolName, refreshPoolsAndClusters } = actionItem;
  const dialogInstance = openReactConfirmationDialog({
    title: Messages.dataConnectSiteSettingsRefreshBaseImageButton(),
    message: Messages.dataConnectSiteSettingsRefreshBaseImageDescription({ NAME: L10n.elideIfLong(poolName) }),
    paramsForAction: { poolId: poolId},
    actionName: Messages.confirm(),
    action: () => {
      return  BaasEdgePoolAndCluster.refreshBaseImage({poolId: poolId, clusterId: clusterId})
      .then((result: IRefreshBaseImageResult) => {
        refreshPoolsAndClusters();
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsRefreshBaseImageSuccess({ NAME: L10n.elideIfLong(poolName) }) });
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve({});
      });
    },
    isActionDelete: false,
    dialogWidth: TabDialogWidth.width375px
  });

  return Promise.resolve(dialogInstance.result);
}
